import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SelectedEmployeeSearchVO } from 'src/app/digigov/models/caseview.model';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { CommuniqueService } from '../communique.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Event } from '@angular/router';

@Component({
  selector: 'app-new-communique',
  templateUrl: './new-communique.component.html',
  styleUrls: ['./new-communique.component.scss'],
})
export class NewCommuniqueComponent implements OnInit {
  @Input('isFirst') isFirst = false;
  @Input('communiqueData') communiqueData = null;
  @Output() refreshCommunique = new EventEmitter<boolean>();
  @Output() cancelCommunique = new EventEmitter<boolean>();
  @Output() closeCommunique = new EventEmitter<boolean>();
  lineHeightList = '1;1.25;1.5;2;2.25;2.75;3;4';
  public editorConfig1: any = {
    height: '70%',
    width: '100%',
    removePlugins: 'scayt',
    disableNativeSpellChecker: false,
    removeButtons:
      'Print,Save,NewPage,ExportPdf,Preview,Templates,PasteFromWord,Replace,SelectAll,Scayt,Form,Checkbox,Radio,Textarea,Button,ImageButton,Subscript,Superscript,RemoveFormat,NumberedList,BulletedList,Blockquote,CreateDiv,Language,Link,Unlink,Anchor,Image,Flash,HorizontalRule,Smiley,PageBreak,Iframe,Maximize,ShowBlocks,About',
    uiColor: '#7964b1',
    allowedContent: true,
    delayIfDetached: true,
    line_height: this.lineHeightList,
    extraPlugins: ['base64image', 'lineheight', 'pastebase64'],
    contentsCss: ['/assets/custom-ckeditor.css'],
    extraAllowedContent: '*{*}',
    pasteFilter: null,
  };
  showTimePicker = false;
  empConfig = {
    multiSelect: true,
    header: 'Send to Many',
    subTitle: 'Employee',
    selectedSubTitle: 'SelectedRecipients',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
  };
  empConfigTo = {
    multiSelect: true,
    header: 'Send to Many',
    subTitle: 'Employee',
    selectedSubTitle: 'SelectedRecipients',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters',
    required: true,
  };
  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'false',
    multiselect: false,
    header: 'Organization Search',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters ',
  };
  isRefresh = false;
  today = new Date();
  attachPath: any;
  appAcceptedType = [
    'pdf',
    'png',
    'doc',
    'jpeg',
    'jpg',
    'xlsx',
    'csv',
    'docx',
    'xls',
  ];
  appMaxSize = 50;
  appMaxFiles = 15;
  multipleAllowed = true;
  isEdit = true;
  appAttachID = '';
  attachmentTitle = ''; //title
  attachmentID = 'Attach'; //any name for attchment component
  isMandatory = true;
  isAllowUpdate = true; //ignore it as currently not in use
  isAllowFileToAttach = true; //to restrict from uploading doc
  isAllowDelete = true; //to restrict from deleting any doc
  attachSmall = true;
  isDownload = true;
  minDate: Date;
  refreshComponent: true;
  newCommuniqueForm = new FormGroup({
    toEmployee: new FormControl(null),
    ccEmployee: new FormControl(null),
    bccEmployee: new FormControl(null),
    subject: new FormControl(null),
    communiqueDetails: new FormControl(null, [Validators.required]),
    category: new FormControl(null),
    expectedClosureDt: new FormControl(null),
    attachments: new FormControl(null),
  });

  communiqueTypes = [
    { label: 'Do Not Reply', id: 'dntReply', value: false, disabled: false },
    { label: 'Do Not Forward', id: 'dntFrwrd', value: false, disabled: false },
    { label: 'Reply Must', id: 'reminderFlag', value: false, disabled: false },
    { label: 'On Priority', id: 'onPriority', value: false, disabled: false },
  ];

  array = [
    {
      name: 'Specific',
      id: 146,
      checked: false,
    },
    {
      name: 'Generic (Information)',
      id: 145,
      checked: true,
    },
  ];
  loggedInUserPostId = null;
  dialogData = null;
  toList = [];
  ccList = [];
  bccList = [];
  appTempPath: string = '';
  isAttachmentAttached: boolean = false;
  isAttachmentAdded: boolean = false;

  constructor(
    private http: HttpClient,
    private communiqueService: CommuniqueService,
    @Optional() public dialogRef: MatDialogRef<NewCommuniqueComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public caseData: any
  ) {
    const today = new Date();
    const tommorrow = new Date(today);
    tommorrow.setDate(today.getDate() + 1);
    this.minDate = tommorrow;
  }

  ngOnInit(): void {
    if (!this.isFirst) {
      if (this.communiqueData) {
        this.communiqueTypes.forEach((type) => {
          if (this.communiqueData[type.id])
            type.value = this.communiqueData[type.id] ? true : false;
        });
        this.toList = this.communiqueData.instSentTo.includes(',')
          ? this.communiqueData.instSentTo.split(',')
          : [this.communiqueData.instSentTo];

        this.ccList = this.communiqueData.instCcTo.includes(',')
          ? this.communiqueData.instCcTo.split(',')
          : [this.communiqueData.instCcTo];

        this.bccList = this.communiqueData.instBCcTo.includes(',')
          ? this.communiqueData.instBCcTo.split(',')
          : [this.communiqueData.instBCcTo];

        this.newCommuniqueForm.controls['subject'].setValue(
          this.communiqueData.instSub
        );

        this.newCommuniqueForm.controls['communiqueDetails'].setValue(
          this.communiqueData.instDtl
        );

        this.appAttachID =
          this.communiqueData.attachId === -1
            ? ''
            : this.communiqueData.attachId;

        for (let a in this.array) {
          if (this.array[a].id === Number(this.communiqueData.instCtg)) {
            this.array[a].checked = true;
          } else {
            this.array[a].checked = false;
          }
        }

        if (this.communiqueData.instCtg.toString() === '146') {
          this.showTimePicker = true;
          this.newCommuniqueForm.controls['expectedClosureDt'].setValue(
            this.communiqueData.expectedCloseDt
          );
        }
      } else if (this.caseData) {
        this.toList = [this.caseData?.fileOwnerUnit?.value];
      } else {
        this.dialogData = this.communiqueService.dialogData;

        this.isMandatory = this.dialogData.data?.isFromReplyWithOutAttachment
          ? false
          : true;
        this.isAttachmentAttached = this.isMandatory;
        this.toList = this.dialogData.data?.instSentTo.includes(',')
          ? this.dialogData.data?.instSentTo.split(',')
          : [this.dialogData.data?.instSentTo];

        this.ccList = this.dialogData.data?.instCcTo.includes(',')
          ? this.dialogData.data?.instCcTo.split(',')
          : [this.dialogData.data?.instCcTo];

        this.bccList = this.dialogData.data?.instBCcTo.includes(',')
          ? this.dialogData.data?.instBCcTo.split(',')
          : [this.dialogData.data?.instBCcTo];

        this.newCommuniqueForm.controls['subject'].setValue(
          this.dialogData.data?.instSub
        );

        this.newCommuniqueForm.controls['communiqueDetails'].setValue(
          this.dialogData.data?.instDtl
        );

        this.appAttachID =
          this.dialogData.data?.attachId === '-1'
            ? ''
            : this.dialogData.data?.attachId;

        for (let a in this.array) {
          if (this.array[a].id === Number(this.dialogData.data?.instCtg)) {
            this.array[a].checked = true;
          } else {
            this.array[a].checked = false;
          }
        }

        if (this.dialogData.data?.instCtg === '146') {
          this.showTimePicker = true;
          this.newCommuniqueForm.controls['expectedClosureDt'].setValue(
            this.dialogData.data.expectedCloseDt
          );
        }
      }
    }
  }

  updateSelectedOption(optionId: string, event): void {
    let isChecked = (event.target as HTMLInputElement).checked;
    const communiqueTypetoUpdate = this.communiqueTypes.find(
      (type) => type.id === optionId
    );
    if (communiqueTypetoUpdate) {
      communiqueTypetoUpdate.value = isChecked;
      if (optionId === 'dntReply') {
        const replyMustType = this.communiqueTypes.find(
          (type) => type.id === 'reminderFlag'
        );
        if (replyMustType) {
          replyMustType.disabled = isChecked;
        }
      } else if (optionId === 'reminderFlag') {
        const doNotReplyType = this.communiqueTypes.find(
          (type) => type.id === 'dntReply'
        );
        if (doNotReplyType) {
          doNotReplyType.disabled = isChecked;
        }
      }
    }
  }
  getData2toEmployee(val) {
    this.newCommuniqueForm.controls['toEmployee'].setValue(val);
  }

  getData2ccEmployee(val) {
    this.newCommuniqueForm.controls['ccEmployee'].setValue(val);
  }

  getData2bcc(val) {
    this.newCommuniqueForm.controls['bccEmployee'].setValue(val);
  }

  /* const pathPattern: RegExp = /^d+$/;
    this.attachPath = finalPath;
    if (this.attachPath !== '') {
      if (!pathPattern.test(this.attachPath)) {
        this.attachmentMandatoryFlag = true;
      }
    } else if (Number(this.caseVO.attachId) > -1) {
      this.attachmentMandatoryFlag = true;
    } else {
      this.attachmentMandatoryFlag = false;
    } */

  onFinalPath(event) {
    this.appTempPath = event;
    if (this.appTempPath.length > 9) {
      this.isAttachmentAttached = true;
    } else if (this.isMandatory && this.appTempPath) {
      this.isAttachmentAttached = false;
    }
  }

  onFinalPathInitial(event) {
    this.appTempPath = event;
    if (this.appTempPath) {
      this.isAttachmentAdded = true;
    } else {
      this.isAttachmentAdded = false;
    }
  }

  onCategoryChange(event) {
    if (event.value === 146) {
      this.showTimePicker = true;
    } else {
      this.showTimePicker = false;
    }
  }

  getValue(id: string): boolean {
    const commType = this.communiqueTypes.find((type) => type.id === id);
    return commType?.value;
  }

  onSubmitClick() {
    let dataForPost = {
      nodeId: this.caseData ? this.caseData?.fileId : '',
      reminderFlag: this.getValue('reminderFlag') ? 1 : 0,
      onPriority: this.getValue('onPriority') ? 1 : 0,
      dntReply: this.getValue('dntReply') ? 1 : 0,
      dntFrwrd: this.getValue('dntFrwrd') ? 1 : 0,
      bccTo: this.newCommuniqueForm.get('bccEmployee').value
        ? this.newCommuniqueForm.get('bccEmployee').value.map(
            (emp) =>
              ({
                empId: emp?.EMP_ID,
                unitId: emp?.UNIT_ID,
                postId: emp?.POST_ID,
                //totalCnt: -1,
              } as SelectedEmployeeSearchVO)
          )
        : [],

      ccTo: this.newCommuniqueForm.get('ccEmployee').value
        ? this.newCommuniqueForm.get('ccEmployee').value.map(
            (emp) =>
              ({
                empId: emp?.EMP_ID,
                unitId: emp?.UNIT_ID,
                postId: emp?.POST_ID,
                //totalCnt: -1,
              } as SelectedEmployeeSearchVO)
          )
        : [],
      instStatus: 143, //default open
      expectedCloseDt: this.newCommuniqueForm.get('expectedClosureDt').value,
      actualCloseDt: this.today,
      instType: 199, //default
      replyCount: 0,

      instSub: this.newCommuniqueForm.get('subject').value,
      operationType: 'NEW',
      instDtl: this.newCommuniqueForm.get('communiqueDetails').value,
      langId: 1,
      instCtg: this.newCommuniqueForm.get('category').value
        ? this.newCommuniqueForm.get('category').value
        : 145,
      locId: 1,
      sentTo: this.newCommuniqueForm.get('toEmployee').value
        ? this.newCommuniqueForm.get('toEmployee').value.map(
            (emp) =>
              ({
                empId: emp?.EMP_ID,
                unitId: emp?.UNIT_ID,
                postId: emp?.POST_ID,
                //totalCnt: -1,
              } as SelectedEmployeeSearchVO)
          )
        : [],
      docAttachmentKey: this.appTempPath,
      showAttachmentFlag: 'false',
      prntInstNo: -1,
      jobRefId: -1,
    };

    if (
      this.dialogData?.data?.operationType === 'REPLY' ||
      this.dialogData?.data?.operationType === 'FORWARD'
    ) {
      dataForPost.operationType = this.dialogData.data.operationType;
      dataForPost.prntInstNo = this.dialogData.data?.instNo;
      dataForPost.jobRefId = this.dialogData.data?.jobRefId;
      this.http
        .post('/worklist/replyorforward-communique', dataForPost)
        .subscribe(() => {
          if (this.dialogRef) {
            this.dialogRef.close();
          } else {
            this.close.emit(true);
          }
        });
    } else {
      this.http
        .post('/worklist/new-communique', dataForPost)
        .subscribe((res) => {
          if (res) {
            if (this.dialogRef) {
              this.dialogRef.close();
            } else {
              this.close.emit(true);
            }
          }
        });
    }
  }
  @Output() close = new EventEmitter<boolean>();
  onSaveAsDraftClick(): void {
    let dataForPost = {
      reminderFlag: this.getValue('reminderFlag') ? 1 : 0,
      onPriority: this.getValue('onPriority') ? 1 : 0,
      dntReply: this.getValue('dntReply') ? 1 : 0,
      dntFrwrd: this.getValue('dntFrwrd') ? 1 : 0,
      showAttachmentFlag: 'false',
      draftShow: '1', //1 for draft 0 for new commujnique

      bccTo: this.newCommuniqueForm.get('bccEmployee').value
        ? this.newCommuniqueForm.get('bccEmployee').value.map(
            (emp) =>
              ({
                //empId: emp?.EMP_ID,
                //unitId: emp?.UNIT_ID,
                postId: emp?.POST_ID,
                //totalCnt: -1,
              } as SelectedEmployeeSearchVO)
          )
        : [],

      ccTo: this.newCommuniqueForm.get('ccEmployee').value
        ? this.newCommuniqueForm.get('ccEmployee').value.map(
            (emp) =>
              ({
                //empId: emp?.EMP_ID,
                //unitId: emp?.UNIT_ID,
                postId: emp?.POST_ID,
                //totalCnt: -1,
              } as SelectedEmployeeSearchVO)
          )
        : [],
      instStatus: 143, //default open
      expectedCloseDt: this.newCommuniqueForm.get('expectedClosureDt').value,
      actualCloseDt: this.today,
      instType: 199, //default
      replyCount: 0,

      instSub: this.newCommuniqueForm.get('subject').value,
      operationType: 'DRAFT',
      instDtl: this.newCommuniqueForm.get('communiqueDetails').value,
      langId: 1,
      instCtg: this.newCommuniqueForm.get('category').value
        ? this.newCommuniqueForm.get('category').value
        : 145,
      locId: 1,

      sentTo: this.newCommuniqueForm.get('toEmployee').value
        ? this.newCommuniqueForm.get('toEmployee').value.map(
            (emp) =>
              ({
                //empId: emp?.EMP_ID,
                //unitId: emp?.UNIT_ID,
                postId: emp?.POST_ID,
                //totalCnt: -1,
              } as SelectedEmployeeSearchVO)
          )
        : [],
      docAttachmentKey: this.appTempPath,
    };

    this.http
      .post('/worklist/draft-communique', dataForPost)
      .subscribe((res) => {
        if (res) {
          if (this.dialogRef) {
            this.dialogRef.close();
          } else {
            this.close.emit(true);
          }
        }
      });
  }
  onCancel() {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.close.emit(true);
    }
  }
}
